export default __webpack_public_path__ + "static/media/01_photo.c58bd727.jpeg";